function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var Teaser = require('./teaser');

/**
 * Teasers — renders Arcade's Game list as Teaser tiles.
 */
var ArcadeTeasers = /*#__PURE__*/function () {
  function ArcadeTeasers(app, mod, container) {
    _classCallCheck(this, ArcadeTeasers);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.teasers = [];
  }
  return _createClass(ArcadeTeasers, [{
    key: "render",
    value: function render() {
      var _this = this;
      var el = document.querySelector(this.container);
      if (!el) {
        return;
      }
      this.teasers = [];
      var html = '';
      for (var i = 0; i < this.mod.games.length; i++) {
        var game = this.mod.games[i];
        var teaser = new Teaser(this.app, this.mod, game);
        this.teasers.push(teaser);
        html += teaser.renderHTML();
      }
      var add_teaser = new Teaser(this.app, this.mod, null, {
        is_add_game: true
      });
      this.teasers.push(add_teaser);
      html += add_teaser.renderHTML();
      el.innerHTML = html;
      Array.from(el.querySelectorAll('.teaser')).forEach(function (node, idx) {
        if (_this.teasers[idx]) {
          _this.teasers[idx].bind(node);
        }
      });
    }
  }]);
}();
module.exports = ArcadeTeasers;